import { useRouter } from "next/router";
import { RnShield } from "@remi/icons/next";
import { strings } from "@remi/localization";
import { RemiButton } from "@remi/next-ui";

import { useMfaEnrollmentPrompt } from "~/hooks/useMfaEnrollmentPrompt";

export const MfaEnrollmentBanner = () => {
  const router = useRouter();
  const { shouldShow, dismiss, needsCredentials } = useMfaEnrollmentPrompt();

  if (!shouldShow) {
    return null;
  }

  const copy = needsCredentials
    ? strings.shared.auth.mfa.enrollmentBanner.needsCredentials
    : strings.shared.auth.mfa.enrollmentBanner.hasCredentials;

  return (
    <div className="flex w-full items-center justify-between border-border-accent border-b-[1px] bg-background-accentLight p-4">
      <div className="flex items-center">
        <RnShield className="text-icon-primary" />
        <p className="ml-3 text-text-primary text-xs">{copy.description}</p>
      </div>
      <div className="flex items-center gap-4">
        <RemiButton
          variant="none"
          className="text-text-tertiary text-xs transition-colors hover:text-text-secondary"
          onClick={dismiss}
        >
          {copy.dismiss}
        </RemiButton>
        <RemiButton
          variant="primary"
          size="md"
          appearance="pill"
          onClick={() => void router.push("/settings/security")}
        >
          {copy.action}
        </RemiButton>
      </div>
    </div>
  );
};
